import { render, staticRenderFns } from "./CredoresSettings.vue?vue&type=template&id=7f5dc440"
import script from "./CredoresSettings.vue?vue&type=script&lang=js"
export * from "./CredoresSettings.vue?vue&type=script&lang=js"
import style0 from "./CredoresSettings.vue?vue&type=style&index=0&id=7f5dc440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports